import React from 'react';
import DefaultComponent from './FavoritePage';
import rootStore from 'root/store';

const { cart, favorite } = rootStore;

const FavoritePage = () => <DefaultComponent cart={cart} favorite={favorite} />;

export default FavoritePage;
